import React from 'react';
import { Reveal } from '../ui/Reveal';

export const About = () => {
  const stats = [
    ["25+", "Student Projects"],
    ["3", "Institutional Projs"],
    ["5", "AI Tools"],
    ["∞", "Still going"]
  ];

  const values = [
    ["Clarity over cleverness", "We'd rather write obvious code than elegant code that nobody else understands."],
    ["Ship, then improve", "A working product with rough edges beats a perfect design that never launches."],
    ["Honest estimates", "We'd rather tell you something takes longer than overpromise and scramble."],
    ["Own the outcome", "We're not just the people who built it. We care what happens after it's live."]
  ];

  return (
    <section className="sec" id="about">
      <Reveal><div className="slabel">Who we are</div></Reveal>
      <Reveal delay="1"><h2 className="stitle">A small studio<br/>doing <em>real work</em></h2></Reveal>
      <div className="agrid">
        <Reveal delay="1">
          <div className="abody">
            <p>Nismay Studios started as a single person with a laptop and a folder full of half-baked ideas. It's still small — intentionally. We think small teams move faster, make better decisions and give a damn about the details.</p>
            <p>We're based in <strong>Gulbarga, Karnataka</strong> and we build across healthcare tech, education, AI tools and productivity. Some projects are for clients. Some are for us. All of them are built to work properly.</p>
            <p>The studio isn't a factory. We take on work we believe in, ship things we're not embarrassed by and try to leave every codebase cleaner than we found it.</p>
          </div>
        </Reveal>
        <Reveal delay="2">
          <div className="aright">
            <div className="swrap">
              {stats.map(([n, l]) => (
                <div className="sbox" key={l}>
                  <div className="sn">{n}</div>
                  <div className="sl">{l}</div>
                </div>
              ))}
            </div>
            <div className="values">
              {values.map(([t, b]) => (
                <div className="vrow" key={t}>
                  <div className="vdot"/>
                  <div className="vtxt"><strong>{t}</strong>{b}</div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};